// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { camelCase } from 'lodash';

export function camelCaseToTitleCase(text?: string): string {
    if (!text) {
        return '';
    }
    const result = text.replace(/([A-Z])/g, ' $1');
    // Capitalize the first letter
    return result.charAt(0).toUpperCase() + result.slice(1);
}

// Based on https://stackoverflow.com/questions/12931828/convert-returned-json-object-properties-to-lower-first-camelcase
export function toCamel(pascalCasedObject: any): any {
    if (pascalCasedObject instanceof Array) {
        return pascalCasedObject.map((value) => {
            let newValue = value;
            if (typeof value === 'object') {
                newValue = toCamel(value);
            }
            return newValue;
        });
    }

    const newO = {};
    Object.keys(pascalCasedObject).forEach((origKey: string) => {
        // const newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
        const newKey = camelCase(origKey);
        let value = pascalCasedObject[origKey];
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
            value = toCamel(value);
        }
        newO[newKey] = value;
    });

    return newO;
}
